import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // we init with resources
    resources: {
      en: {
        translations: {
          Home: "Home",
          Attendance: "Attendance",
          "Additional Settings": "Additional Settings",
          Requests: "Requests",
          Countries: "Countries",
          Contracts: "Contracts",
          "Salaries and Contracts": "Salaries and Contracts",
          "Branches And Departments": "Branches And Departments",
          currency: "currency",
          Currenciens: "Currenciens",
          Nationalites: "Nationalites",
          Categories: "Categories",
          Pages: "Pages",

          Settings: "Settings",
          SystemSettings: "SystemSettings",
          Salaries: "Salaries",
          Events: "Events",
          Date: "Date",
          "Check In Time": "Check In Time",
          "Check Out Time": "Check Out Time",
          "Work Hours": "Work Hours",
          "Overtime Hours": "Overtime Hours",
          "Late Time": "Late Time",
          "Early Check Out": "Early Check Out",
          Designations: "Designations",
          Employees: "Employees",
          "Add Constracts": "Add Constracts",
          pending: "Pending",
          completed: "completed",
          started: "started",
          onreview: "onreview",
          approved: "Approved",
          refused: "Refused",
          "Enter Page Name": "Enter Page Name",
          "Page Name": "Page Name",
          Currencies: "Currencies",
          Response: "Response",
          Created_at: "Created_at",
          "check in place": "check in place",
          "check out place": "check out place ",
          Banks: "Banks",
          bankswiftcode: "bank swiftcode",
          "bank iban": "bank iban",
          bankstore: "bank store",
          bank_format: "bank_format",
          "Enter  bank_format": "Enter  bank_format",
          "Enter bank iban": "Enter bank iban",
          "Enter bankswiftcode": "Enter bankswiftcode",
          "Marital Status": "Martial Status",
          Religion: "Religion",
          "Blood group": "Blood group",
          Gender: "Gender",
          Address: "Address",
          Email: "Email",
          Birthdate: "Birthdate",
          blood_group: "blood_group",
          Balances: "Balances",
          "Balances Store": "Balances Store",
          contract: "contract",
          employes: "employes",
          used: "used",
          value: "value",
          File: "File",
          expired: "expired",
          undeserved: "undeserved",
          deserved: "deserved",
          "Enter Name": "Enter Name",
          All: "All",
          Done: "Done",
          Tasks: "Tasks",
          Task: "Task",
          package_one: "Package One",
          package_two: "Package Two",
          package_three: "Package Three",
          package_four: "Package Four",
          package_five: "Package Five",
          Choose_Package: "Choose Package",
          amount: "amount",
          days: "days",
          operation_type: "operation_type",
          monthly: "monthly",
          yearly: "yearly",
          weekly: "weekly",
          quarter: "quarter",
          canceled: "canceled",
          absence: "absence",
          overtime: "overtime",
          break: "break",
          fixable: "fixable",
          increase: "increase",
          decrease: "decrease",
          number: "number",
          location: "Location",
          qr: "QR",
          device: "Device",
          device_location: "Device Location",
          auto_device: "Auto Device",
          Face: "Face",
          Voice: "Voice",
          MobileDevice: "Mobile",
          datefrom: "datefrom",
          "date to": "date to",
          "time from": "time from",
          "time to": "time to",
          Main: "Main",
          "Not Main": "Not Main",
          Governorates: "Governorates",
          "Add governatore": "Add governatore",
          "Edit country": "Edit country",

          "Governorates Detalis": "Governorates Detalis",
          Services: "Services",
          "Services Detalis": "Services Detalis",
          "Add services": "Add services",
          Users: "Users",
          "Users Detalis": "Users Detalis",
          governorate: "governorate",
          user_type: "user_type",
          Phone: "Phone",
          "Service Requests": "Service Requests",
          Provider: "Provider",
          "Service Request Detalis": "Service Requests Detalis",
          Service: "Service",
          "Edit governatore": "Edit governatore",
          "Edit Services": "Edit Services",
          Budget: "Budget",
          Slug: "Slug",
          "Add Pages": "Add Pages",
          "Edit Pages": "Edit Pages",
          "Provider Image": "Provider Image",
          "Provider Name": "Provider Name",
          Phone: "Phone",
          "Commercial Name": "Commercial Name",
          Price: "Price",
          "Work Hours": "Work Hours",
          Installments: "Installments",
          Contacted: "Contacted",
          Approved: "Approved",
          Contacts: "Contacts",
          "Contacts Detalis": "Contacts Detalis",
          Message: "Message",
          Seen: "Seen",
          "Admins Detalis": "Admins Detalis",
          "Add Admin": "Add Admins",
          "Confirm Password": "Confirm Password",
          "Edit Admins": "Edit Admins",
          User: "User",
          "Country Code": "Country Code",
          is_connected: "is_connected",
          "Country Name": "Country Name",
          monthly_statistics: " monthly statistics",
          balance_logs: " balance logs",
          provider: "provider",
          service_name: "service_name",
          title: "title",
          description: "description",
          budget: "budget",
          created_at: "created_at",
          payment_method: "payment method",
        },
      },
      ar: {
        translations: {
          weekly: "اسبوعي",
          operation_type: " اختار نوع العملية",
          days: "الأيام",
          Home: " الرئيسية",
          Pages: "الصفحات",
          Articles: "المقالات",
          Next: "التالي",
          "Change Password": "تغيير كمة المرور",
          Prev: "السابق",
          "Rules Detalis": "تفاصيل القواعد",
          "Nationalites Detalis": "تفاصيل الجنسيات",
          Profile: "الملف الشخصي",
          "Designations Detalis": "تفاصيل التعيينات",
          "Shifts Detalis": "تفاصيل الدوام",
          "Departments Detalis": "تفاصيل الأقسام",
          "company rules Detalis": "تفاصيل لائحة الجزاءات",
          "Salaries and Contracts": "المرتبات و العقود",
          Attendance: "الحضور و الانصراف",
          Nationalites: "الجنسبات",
          "Device Detalis": "تفاصيل الجهاز",
          "Salaries Detalis": "تفاصيل المرتبات",
          "Cities Detalis": "تفاصيل المدن",
          designation: "التسمية",
          Designations: "التعيينات",
          department: "القسم",
          "Add Device": "إضافة جهاز",
          duration: "المدة",
          "Add Department": "إضافه قسم",
          "Add Task": "اضافة مهمة",
          "Update company": "تعديل الشركة",
          "Edit Department": "تعديل قسم",
          level: "المستوي",
          Categories: "الفئات",
          start_date: "تاريخ البداية",
          "Add Nationality": "إضافة جنسية",
          Holidays: "الأجازات",
          "Add Holidays": "إضافة أجازات",
          "Branch Detalis": "تفاصيل الفرع",
          "Tasks Detalis": "تفاصيل المهام",
          Tasks: "المهام",
          "Add Category": "اضافة فئه",
          "Add Article": "اضافه مقالة",
          "Add Page": "اضافه صفحة",
          "Edit Constracts": "تعديل العقود",
          "Enter Level": "ادخل المستوي",
          "Edit Company Rules": "تعديل لائحة الجزاءات",
          "categories Detalis": "تفاصيل الفئات",
          "Add Company Rules": "اضافة لائحة جزاءات",
          "Designations Information": "معلومات  التعيينات",
          Time: "الوقت",
          "Add Designation": "اضافه تعيينات",
          "Salaries Detalis": "تفاصيل المرتبات",
          "Contract Detalis": "تفاصيل العقد",
          "duration type": "نوع المدة",
          "Add Constracts": "اضافه عقود",
          Employe: "الموظف",
          "Enter Amount": "ادخل القيمة",
          Amount: "القيمة",
          Type: "النوع",
          "Amount Type": "نوع القيمة",
          "Choose Amount Type": "اختار نوع القيمة",
          "Enter Description": "ادخل الوصف",
          "Requests Detalis": "تفاصيل الطلبات",
          "Payllors Detalis": "تفاصيل كشف المرتبات",
          "Choose Company": "اختار الشركة",
          "Choose Type": "اختار النوع",
          Image: "الصوره",
          start_date: "تاريخ البداية",
          end_date: "تاريخ الانتهاء",
          join_date: "تاريخ الانضمام",
          deserved_amount: "المبلغ المستحق",
          status: "الحالة",
          "desreved amount": "القيمة المستحقة",
          undeserved_amount: "القيمة غير المستحقة",
          loan_amount: "مبلغ القرض",
          Level: "المستوي",
          discount_amount: "قيمة الخصم",
          extra_amount: "مبلغ إضافي",
          Admin: "المدير",
          days: "الأيام",
          Saturday: "السبت",
          "Add Deductions": "اضافة خصومات",
          PaidDate: "تاريخ الدفع",
          Amount_Type: "نوع القيمة",
          Sunday: "الأحد",
          Monday: "الأثنين",
          Tuesday: "الثلاثاء",
          Payrolls: "كشوف المرتبات",
          type: "النوع",
          fixed: "ثابت",
          percent: "نسبة",
          amount_type: "نوع القيمة",
          Salary: "المرتب",
          late_time: "وقت التأخير",
          date: "التاريخ",
          company: "الشركة",
          salary: "المرتب",
          "company fields Detalis": "تفاصيل مجالات الشركة",
          check_in_type: "نوع تسجيل الحضور",
          Deductions: "الخصومات",
          employe: "موظف",
          Mobile: "رقم الهاتف",
          MobileDevice: "هاتف",
          "Late Check In": "الحضور متأخرا",
          Bouns: "المكافئات",
          "Employe Name": "اسم الموظف",
          Discount: "الخصم",
          "Holiday includes": "تشمل الأجازات",
          "Holiday not includes": "لاتشمل الأجازات",
          "Early Check Out": "انصراف مبكر",
          "Edit Employ": "تعديل موظف",
          "Devices Detalis": "تفاصيل الجهاز",
          check_out_type: "نوع تسجيل الانصراف",
          in_branch: "في الفرع",
          in_time: "في الوقت المناسب",
          paid_date: "تاريخ الدفع",
          paid: "مدفوع",
          Duration: "المده",
          Sort: "الترتيب",
          "Salaries and Constractors": "المرتبات و العقود",
          "General Settings": "اعدادات عامة",
          Currencies: "العملات",
          Issue_date: "تاريخ اللإصدار",
          Wednesday: "الاربعاء",
          "Branches And Departments": "الفروع و الأقسام",
          Employees: "الموظفين",
          Rules: "القواعد",
          Slug: "الاسم المستعار",
          Type: "النوع",
          Thursday: "الخميس",
          "Add Salary": "إضافة مرتب",
          Friday: "الجمعة",
          Name_Ar: "الاسم باللغة العربية",
          Name_En: "الاسم باللغة الانجليزية",
          nation_id: "  رقم الهوية الوطنية",
          role: "الدور",
          Procedures: "الاجرائات",
          "Add Payrolls": "إضافة دفتر المرتبات",
          "Attendances Detalis": "تفاصيل الحضور و  الانصراف",
          "Salaries Detalis": "تفاصيل المرتبات",
          Departments: "الأقسام",
          "Add Employ": "اضافة موظف",
          Department: "القسم",
          "start time": "وقت البداية",
          "end time": "وقت الانتهاء",
          "start checkin": "وقت الحضور",
          "end checkin": "انتهاء الحضور",
          Employes: "الموظفين",
          "start checkout": "بداية الانصراف",
          "end checkout": " انتهاء الانصراف",
          Device: "الجهاز",
          "start break": "بداية الاستراحة",
          "end break": "انتهاء الاستراحة",
          "flexible hours": "ساعات مرنة",
          flexible: "مرن",
          break: "الاستراحة",
          Companies: "الشركات",
          "day off": "يوم عطلة",
          Currenciens: "العملات",
          Countries: "الدول",
          Field: "المجال",
          "Additional Settings": "اعدادت اضافية",
          "Country Detalis": "تفاصيل الدوله",
          "EmploymentTypes Detalis": "تفاصيل انواع العمالة",
          "Add country": "اضافة دولة",
          "Add city": "اضافة مدينة",
          "Add Level": "اضافة مستوي",
          "Add shift": "اضافة نوبة عمل",
          "Add company": "اضافة شركة",
          Cites: "المدن",
          Requests: "الطلبات",
          Shifts: " الدوام",
          "Edit Employe Request": "تعديل طلبات الموظفين",
          "Edit Employment Type": "تعديل انواع العمالة",
          "Edit Salary": "تعديل المرتبات",
          "Edit Level": "تعديل المستوي",
          "Add Employment Type": "اضافة نوع عمالة",
          Branches: "الفروع",
          Company: "الشركة",
          "Add Branch": "إضافة فرع",
          "Empolyment Types": "أنواع العمالة",
          Levels: "المستويات",
          "Levels Detalis": "تفاصيل المستويات",
          "Add Empolyment Type": "إضافه نوع عماله",
          "Work Shifts": "الدوام",
          "Comapny Fields": "مجالات الشركة",
          Branches: "الفروع",
          "Add Request": "اضافه طلب",
          Loan: "السلفة",
          "Comapny Rules": "لائحة الجزاءات",
          "Add Employe Request": "اضافة طلبات الموظفين",
          website: "الموقع الالكتروني",
          email: "البريد الالكتروني",
          "Company Detalis": "تفاصيل الشركة",
          "Phone-code": "رمز الهاتف الدولي",
          Nationalities: "الجنسيات",
          "Add Company Field": "إضافة مجال الشركة",
          Roles: "الادوار",
          Currency: "العملة",
          Symbol: "الرمز",
          Rate: "المعدل",
          Default: "افتراضي",
          Symbol: "الرمز",
          Request: "طلب",
          SystemSettings: "اعدادت النظام",

          work_hours: "ساعات العمل-الاستراحه",
          out_time: "توقيت الانصراف",
          Task: "مهمة",
          settings: "الاعدادت",
          Expired_at: "تاريخ الانتهاء",
          Settings: "الاعدادات",
          Visits: "الزيارات",
          "Edit Request": "تعديل نوع الطلب",
          Opreation: "العملية",
          Show: "عرض",
          "Edit Branch": "تعديل الفرع",
          "Add EmployeAttachments": "اضافة ملحقات الموظفين",
          Salaries: "  مكونات الراتب",
          "Edit Page": "تعديل الصفحات",
          "Edit Article": "تعديل المقاله",
          "Edit Category": "تعديل الفئة",
          "Edit Designation": "تعديل التعيينات",
          "Add Rules": "اضافه قواعد",
          system_adminstrator: "مدير النظام",
          branch_adminstrator: "مدير الفرع",
          department_adminstrator: "مدير القسم",
          adminstrator: "المدير",
          Events: "المهام",
          "Date from": "التاريخ من",
          Issue_Date: "تاريخ الإصدار",
          constracts: " العقود",
          "Edit shift": "تعديل الدوام",
          requestsTypes: "انواع الطلبات",
          "Add Attendance": "اضافة حضور",
          "Add Constracts": "اضافة عقود",
          "Date To": "التاريخ إلي",
          Quantity: "الكمية",
          "Add Bouns": " اضافة مكافئة ",
          "Time From": "الوقت من",
          "Time To": "الوقت إلي",
          "Date To ": "التاريخ إلي",
          "End Date": "تاريخ الانتهاء",
          "Log out": "تسجيل خروج",
          Hello: "مرحبا",
          "Attendance has been recorded": "تم تسجيل الحضور",
          branch: "الفرع",
          "Working Hours": "الدوام",
          Contracts: "العقود",
          "Requests Types": "انواع الطلبات",
          "Employe Requests": "طلبات الموظفين",
          "No attendance registered today": "لم يتم تسجيل الحضور اليوم",
          Name: "الاسم",
          Note: "ملاحظه",
          "Empolyes Requests Detalis": "تفاصيل طلبات الموظفين",
          "Employes Detalis": "تفاصيل الموظفين",
          DateTo: "التاريخ إلي",
          Country: "الدولة",
          Date: "التاريخ",
          "Check In Time": "وقت الحضور",
          "Check Out Time": "وقت الانصراف",
          "Work Hours": "ساعات العمل",
          "Overtime Hours": "الساعات الاضافيه",
          "Late Time": "وقت التأخير",
          "Early Check Out": "وقت الانصراف المبكر",
          "profile page": "صفحة البروفايل",
          "Request Type": "نوع الطلب",
          "Request Status": "حاله الطلب",
          "Request Date": "تاريخ الطلب",
          Reason: "السبب",
          "Show Request": "مشاهده الطلب",
          Login: "تسجيل الدخول",
          "Enter your email & password to login":
            " ادخل الايميل و الباسورد لتسجيل الدخول ",
          Sign: "تسجيل",
          "Email Address": "البريد الإلكتروني",
          ready_for_delivery: "جاهز للاستلام",
          pending: "بانتظار المراجعة",
          confirmed: "تم تأكيد الطلب",
          processing: "جار تجهيز الطلب",
          on_the_way: "في طريق التوصيل",
          delivered: "تم تسليم الطلب",
          Password: "كلمة المرور",
          RememberPassword: "تذكر الباسورد",
          "Task Title": "عنوان المهمة",
          Employee: "الموظف",
          Description: "الوصف",
          Service: "الخدمة",
          Branch: "الفرع",
          Status: "الحالة",
          "Branch Name": "اسم الفرع",
          January: "يناير",
          February: "فبراير",
          March: "مارس",
          April: "ابريل",
          May: "مايو",
          Category: "الفئة",
          Active: "مفعل",
          InActive: "غير مفعل",
          Actions: "العمليات",
          "Pages Detalis": "تفاصيل الصفحات",
          "Page Name": "اسم الصفحة",
          application: "ابلكيشن",
          "not application": "ليس ابلكيشن",
          "Enter Page Name": "ادخل اسم الصفحة",
          "There are no salaries for this employee currently":
            "لاتوجد مرتبات لهذا الموظف حاليا",
          "General Settings": "الإعدادات العامة",
          "Services Management": "إدارة الخدمات",
          "Members & Transactions": "إدارة الأعضاء والمعاملات",
          "Communication & Interaction": "التواصل والتفاعل",
          "System Administration": "إدارة النظام",
          calculate: "حساب",
          "Refues Reason": "سبب الرفض",
          Map: "الخريطة",
          "bank iban": "رقم الحساب المصرفي ",
          pending: "في الانتظار",
          Pending: "غير موافق عليه",
          Inactive: "غير مفعل",
          "Phone Verified": "تم التحقق من الهاتف",
          "Phone Unverified": "لم يتم التحقق من الهاتف",
          approved: "تم الموافقة",
          refused: "تم الرفض",
          Checkin: " الحضور",
          Checkout: "الانصراف",
          Absent: "الغياب",
          "Early Checkout": "الانصراف مبكرا",
          Response: "الرد",
          cancelled: " تم الإلغاء",
          Created_at: " تم الإنشاء في",
          "check in place": "مكان تسجيل الحضور",
          "check out place": "مكان  تسجيل الانصراف",
          Banks: "البنوك",
          bankswiftcode: "بنك سويفت كود",
          "User Balance Logs": "سجلات رصيد المستخدم",
          "change password": "تغيير كلمة المرور",
          "Service Offer Installments": "أقساط عروض الخدمات",
          "issue at": "تم الإصدار في",
          updated_at: "تم التعديل في",
          bankstore: "إضافة بنوك ",
          bank_format: " تنسيق البنك",
          "Enter bankswiftcode": "ادخل بنك سويفت كود",
          "Enter  bank_format": "ادخل تنسيق البنك",
          "Enter bank iban": "ادخل الرقم المصرفي",
          "Marital Status": "الحالة الإجتماعية",
          Religion: "الدين",
          "Blood group": "فصيلة الدم",
          Gender: "النوع",
          Address: "العنوان",
          Email: " البريد الإلكتروني",
          Birthdate: "تاريخ الميلاد",
          blood_group: "فصيلة الدم",
          Balances: "الأرصدة",
          "Balances Store": "إضافة أرصدة",
          contract: "العقد",
          employes: "الموظفين",
          used: "المستخدم",
          value: "الرصيد",
          File: "ملف",
          completed: "مكتمل",
          onreview: "جاري المراجعة",
          started: "تم البدء",
          expired: "منتهي الصلاحية",
          undeserved: "غير مستحق",
          deserved: "مستحق",
          "Enter Name": "ادخل الاسم",
          All: "الكل",
          Done: "الانجاز",
          Tasks: "المهام",
          package_one: "الحزمة الأولى",
          package_two: "الحزمة الثانية",
          package_three: "الحزمة الثالثة",
          package_four: "الحزمة الرابعة",
          package_five: "الحزمة الخامسة",
          Choose_Package: "اختار الحزمة",
          monthly: "شهري",
          yearly: "سنوي",
          quarter: "ربع سنوي",
          canceled: "ملغي",
          absence: "غياب",
          overtime: "عمل إضافي",
          break: "استراحة",
          fixable: "قابل للتعديل",
          increase: "زيادة",
          decrease: "إنقاص",
          number: "عدد",
          location: "الموقع",
          qr: "كيو آر",
          device: "جهاز",
          device_location: "موقع الجهاز",
          auto_device: "جهاز تلقائي",
          Face: "بصمة وجه",
          Voice: "بصمة صوت",
          datefrom: "التاريخ من",
          "date to": "التاريخ إلي",
          "time from": "التوقيت من",
          "time to": "التوقيت إلي",
          Admins: "المدراء",
          Moderators: "المشرفون",
          Main: "أساسية",
          "Not Main": "غير أساسية",
          Governorates: "المحافظات",
          "Add governatore": "إضافة محافظات",
          "Edit country": "تعديل الدولة",
          "Governorates Detalis": "تفاصيل المحافظات",
          Services: "الخدمات",
          "Services Detalis": "تفاصيل الخدمات",
          "Add services": "إضافة خدمة",
          Users: "الأعضاء",
          "Users Detalis": "تفاصيل الأعضاء",
          governorate: "المحافظة",
          Phone: "الهاتف المحمول",
          "Service Requests": "طلبات الخدمات",
          Provider: "المزود",
          "Service Request Detalis": "تفاصيل طلبات الخدمات",
          "Edit governatore": "تعديل المحافظة",
          "Edit Services": "تعديل الخدمات",
          Budget: "الميزانية",
          Slug: "الاسم المستعار",
          "Add Pages": "إضافة صفحات",
          "Edit Pages": "تعديل الصفحات",
          "Provider Image": "صورة المزود",
          "Provider Name": "اسم المزود",
          Phone: "الهاتف",
          "Commercial Name": "الاسم التجاري",
          Price: "السعر",
          "Work Hours": "ساعات العمل",
          Installments: "الدفعات",
          Contacted: "تم الاتصال",
          Approved: "موافق عليه",
          Contacts: "الاتصالات",
          "Contacts Detalis": "بيانات المتصلين",
          Message: "الرسالة",
          Seen: "مشاهدة",
          "Admins Detalis": "تفاصيل المدراء",
          "Add Admin": "اضافه مدراء",
          "Confirm Password": "تأكيد كلمة المرور",
          "Edit Admins": "تعديل المدراء",
          User: "مستخدم",
          "Country Code": "كود الدولة",
          is_connected: "تم الاتصال",
          "Country Name": "اسم الدولة",
          monthly_statistics: "إحصائيات شهرية",
          balance_logs: "سجلات الرصيد",
          Notifications: "الإشعارات",
          "user balance logs": "سجلات رصيد المستخدم",
          installments: "الأقساط",
          offers_count: "العروض",
          approved_offer_user: "العروض الموافق عليها",
          user_type: "نوع المستخدم",
          provider: "مزود خدمة",
          service_request_id: "# خدمة",
          price: "السعر",
          work_hour_type: "نوع ساعات العمل",
          offer: "عرض",
          send_date: "تاريخ  اللإرسال",
          contacted: "تم التواصل",
          service_name: "اسم الخدمة",
          title: "العنوان",
          description: "الوصف",
          budget: "الميزانية",
          created_at: "تم الإنشاء في",
          Offers: "العروض",
          withdrawals: "طلبات السحب",
          Withdrawals: "طلبات السحب",
          user: "المستخدم",
          admin_notes: "ملاحظات المدراء",
          amount: "الكمية",
          processed_at: "تمت معالجته في",
          offer_installments: "عروض الأقساط",
          hold_balance_total: "الرصيد المعلق",
          balance: "الرصيد الحالي",
          services: "الخدمات",
          "Service Request Offers": "عروض طلبات الخدمة",
          transactions: "المعاملات",
          Transactions: "المعاملات",
          unpaid: "غير مدفوع",
          paid: "مدفوع",
          "Received Invoices": "الفواتير المستلمة",
          "Sent Invoices": "الفواتير المرسلة",
          Chats: "المحادثات",
          "First User ": " المستخدم الأول",
          "Second User ": " المستخدم الثاني",
          "Chats Detalis": "تفاصيل المحادثات",
          Invoices: "الفواتير",
          payment_method: "طريقة الدفع",
          note: "الملاحظة",
          expires_at: "ينتهي في",
          sender: "المرسل",
          receiver: "المستقبل",
          "Invoices Detalis": "تفاصيل الفواتير",
          "Payment Link": "رابط الدفع",
          "paid at": "تم الدفع في",
          "created at": "تم الإنشاء في",
          slug: "الاسم المستعار",
          "parent service": "الخدمة الرئيسية",
          Reviews: "المراجعات",
          "Service Requests Offers": "عروض طلبات الخدمات",
          approved: "موافق عليه",
          not_approved: "غير موافق عليه",
          store_owner: "مالك المتجر",
        },
      },
    },
    supportedLngs: ["ar", "en"],
    fallbackLng: "en",
    debug: false,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",
    lng: localStorage.getItem("i18nextLng") || "ar",
    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
